<template>
    <el-container style="height: 100%">
        <el-header style="height: 30px;text-align: center;padding-top: 10px">
            <el-button size="mini" type="primary" @click="openStaffAsk">请假</el-button>
            <el-button size="mini" type="primary" @click="openCheckInChange">调休</el-button>
            <el-button size="mini" type="primary" @click="openWDK">忘打卡</el-button>
            <el-button size="mini" type="primary" @click="openLxCheckInChange" v-if="lxShow">连续调休</el-button>
        </el-header>
        <el-main style="height: 100%">
                <el-table :data="tableData"  border size="mini" height="100%" ref="table">
                    <el-table-column label="日期" width="100px" align="center" prop="checkindate"></el-table-column>
                    <el-table-column label="上班" width="100px" align="center" prop="starttime">
                        <template slot-scope="scope">
                            <div>{{scope.row.starttime}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="下班" width="100px" align="center" prop="endtime">
                        <template slot-scope="scope">
                            <div>{{scope.row.endtime}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="出勤扣款" width="100px" align="center" prop="checkamount"></el-table-column>
                    <el-table-column label="请假扣款" width="100px" align="center" prop="askamount"></el-table-column>
                    <el-table-column  width="100px" align="center" prop="endtime">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.checkamount>0 || scope.row.askamount>0" type="primary" size="mini" @click="openApply(scope)">申请</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            <el-dialog title="补卡申请" :visible.sync="dialogVisible" width="100%" top="0px">
                        <van-form @submit.native.prevent>
                            <van-cell-group inset>
                                <van-field v-model="addCheckInReplace.checkindate" readonly label="补卡日期" placeholder="用户名" :rules="[{ required: true, message: '请填写用户名' }]"/>
                            </van-cell-group>
                            <van-cell-group inset>
                                <van-field v-model="addCheckInReplace.typename" @click="showTypePicker=true" readonly label="补卡类型" placeholder="类型" :rules="[{ required: true, message: '请选择上班还是下班' }]"/>
                            </van-cell-group>
                            <van-cell-group inset>
                                <van-field  is-link readonly v-model="addCheckInReplace.checkintime" label="时间选择" placeholder="点击选择时间" @click="showTimePicker = true"/>
                            </van-cell-group>
                            <van-cell-group inset>
                                <van-field name="uploader" label="监控证据">
                                    <template #input>
                                        <van-uploader :before-delete="beforeDelete" v-model="images" :after-read="afterRead" multiple/>
                                    </template>
                                </van-field>
                            </van-cell-group>
                            <van-cell-group inset>
                                <van-field v-model="addCheckInReplace.remarks" rows="1" type="textarea" autosize label="补卡原因"  placeholder="请输入留言"/>
                            </van-cell-group>
                        </van-form>
                        <div style="margin: 16px;">
                            <van-button round block type="primary" :loading="loading" native-type="submit" @click="saveCheckinReplace">提交</van-button>
                        </div>


                <van-popup v-model:show="showTypePicker" position="bottom">
                    <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showTypePicker = false"/>
                </van-popup>
                <!--<van-popup v-model:show="showTypePicker" position="bottom">
                    <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showTypePicker = false"/>
                </van-popup>-->
                <van-popup v-model:show="showTimePicker" position="bottom">
                    <van-datetime-picker type="datetime" v-model="checkdatetime"  @confirm="onTimeConfirm" @cancel="showTimePicker = false" />
                </van-popup>
            </el-dialog>
            <el-dialog title="请假申请" :visible.sync="dialogAskVisible" width="100%" top="0px">
                <van-form @submit.native.prevent>
                    <van-cell-group inset>
                        <van-field v-model="addStaffAsk.askname" readonly label="请假类型" @click="showAskPicker = true" placeholder="请假类型" :rules="[{ required: true, message: '请选择请假类型' }]"/>
                    </van-cell-group>
                    <van-cell-group inset>
                        <van-field v-model="addStaffAsk.startdatename" readonly label="开始时间" @click="showAskDateFromPicker = true" placeholder="开始时间" :rules="[{ required: true, message: '请选择开始时间' }]"/>
                    </van-cell-group>
                    <van-cell-group inset>
                        <van-field v-model="addStaffAsk.enddatename" readonly label="结束时间" @click="showAskEndDateFromPicker = true" placeholder="结束时间" :rules="[{ required: true, message: '请选择结束时间' }]"/>
                    </van-cell-group>
                    <van-cell-group inset>
                        <van-field v-model="addStaffAsk.days" readonly label="请假天数" placeholder="请假天数"/>
                    </van-cell-group>
                    <van-cell-group inset>
                        <van-field v-model="addStaffAsk.reason" rows="1" type="textarea" autosize label="请假原因" placeholder="请假原因"/>
                    </van-cell-group>
                    <van-cell-group inset>
                        <van-field name="uploader" label="请假凭证">
                            <template #input>
                                <van-uploader :before-delete="beforeAskDelete" v-model="askImages" :after-read="afterAskRead" multiple/>
                            </template>
                        </van-field>
                    </van-cell-group>
                    <div style="margin: 16px;">
                        <van-button round block type="primary" :loading="loading" native-type="submit" @click="staffAskApply">提交</van-button>
                    </div>
                </van-form>
                <van-popup v-model:show="showAskPicker" position="bottom">
                    <van-picker show-toolbar :columns="askData" value-key="constantname" @confirm="AskConfirm" @cancel="showAskPicker = false"/>
                </van-popup>
                <van-popup v-model:show="showAskDateFromPicker" position="bottom">
                    <van-picker show-toolbar :columns="askTime"  @confirm="askStartTimeConfirm" @cancel="showAskDateFromPicker = false"/>
                </van-popup>
                <van-popup v-model:show="showAskEndDateFromPicker" position="bottom">
                    <van-picker show-toolbar :columns="askTime"  @confirm="askEndTimeConfirm" @cancel="showAskEndDateFromPicker = false"/>
                </van-popup>
            </el-dialog>
            <el-dialog title="连续调休" :visible.sync="lxDialogVisible" width="100%" top="0px">
                <van-cell-group inset>
                    <van-field v-model="addCheckInChange.changedate" readonly label="开始休息日期" @click="openDate('changedate')" placeholder="开始休息日期"
                               :rules="[{ required: true, message: '开始休息日期' }]"/>
                </van-cell-group>
                <van-cell-group inset>
                    <van-field v-model="addCheckInChange.changedateto" readonly label="结束休息日期" @click="openDate('changedateto')" placeholder="结束休息日期"
                               :rules="[{ required: true, message: '结束休息日期' }]"/>
                </van-cell-group>
                <van-cell-group inset>
                    <van-field v-model="addCheckInChange.days" readonly label="调休天数" placeholder="调休天数"/>
                </van-cell-group>
                <van-cell-group inset>
                    <van-field  v-model="addCheckInChange.tochangedate" readonly label="补班日期1" @click="openDate('tochangedate')" placeholder="补班日期1" v-if="addCheckInChange.days>0"
                               :rules="[{ required: true, message: '补班日期1' }]"/>
                </van-cell-group>
                <van-cell-group inset>
                    <van-field v-model="addCheckInChange.workdate2" readonly label="补班日期2" @click="openDate('workdate2')"
                               placeholder="补班日期2" v-if="addCheckInChange.days>1"
                               :rules="[{ required: true, message: '补班日期2' }]"/>
                </van-cell-group>
                <van-cell-group inset>
                    <van-field v-model="addCheckInChange.workdate3" readonly label="补班日期3" @click="openDate('workdate3')" placeholder="补班日期3" v-if="addCheckInChange.days>2"
                               :rules="[{ required: true, message: '补班日期3' }]"/>
                </van-cell-group>
                <van-cell-group inset>
                    <van-field v-model="addCheckInChange.workdate4" readonly label="补班日期4" @click="openDate('workdate4')" placeholder="补班日期4" v-if="addCheckInChange.days>3"
                               :rules="[{ required: true, message: '补班日期4' }]"/>
                </van-cell-group>
                <van-cell-group inset>
                    <van-field v-model="addCheckInChange.workdate5" readonly label="补班日期5" @click="openDate('workdate5')" placeholder="补班日期5" v-if="addCheckInChange.days>4"
                               :rules="[{ required: true, message: '补班日期5' }]"/>
                </van-cell-group>
                <van-cell-group inset>
                    <van-field v-model="addCheckInChange.remarks" rows="2" autosize label="调休原因" type="textarea" placeholder="请调休原因"/>
                </van-cell-group>
                <div style="margin: 16px;">
                    <van-button round block type="primary" :loading="loading" native-type="submit" @click="saveLxCheckInChange">提交</van-button>
                </div>
                <van-popup v-model:show="lxDateFromPicker" position="bottom">
                    <van-datetime-picker type="date" v-model="lxChangeDateTime"  @confirm="onLxChangeConfirm($event,curDateName)" @cancel="lxDateFromPicker = false" />
                </van-popup>
            </el-dialog>
            <el-dialog title="调休申请" :visible.sync="dialogChangeVisible" width="100%" top="0px">
                <van-form @submit.native.prevent>
                    <van-cell-group inset>
                        <van-field v-model="addCheckInChange.changedate" readonly label="休息日期" @click="showChangeTimePicker = true" placeholder="休息日期" :rules="[{ required: true, message: '请选择休息日期' }]"/>
                    </van-cell-group>
                    <van-cell-group inset>
                        <van-field v-model="addCheckInChange.tochangedate" readonly label="补班日期" @click="showToChangeTimePicker = true" placeholder="补班日期" :rules="[{ required: true, message: '请选择补班日期' }]"/>
                    </van-cell-group>
                    <van-cell-group inset>
                        <van-field v-model="addCheckInChange.remarks" rows="1" autosize label="调休原因" type="textarea" placeholder="请调休原因"/>
                    </van-cell-group>
                    <div style="margin: 16px;">
                        <van-button round block type="primary" :loading="loading" native-type="submit" @click="checkInChangeAppay">提交</van-button>
                    </div>
                </van-form>
                <van-popup v-model:show="showChangeTimePicker" position="bottom">
                    <van-datetime-picker type="date" v-model="changedatetime"  @confirm="onChangeConfirm" @cancel="showChangeTimePicker = false" />
                </van-popup>
                <van-popup v-model:show="showToChangeTimePicker" position="bottom">
                    <van-datetime-picker type="date" v-model="changetodatetime"  @confirm="onToChanageConfirm" @cancel="showToChangeTimePicker = false" />
                </van-popup>
            </el-dialog>
            <el-dialog title="忘打卡" :visible.sync="dialogWDKVisible" width="100%" top="0px">
                <van-form @submit.native.prevent>
                    <!--<van-cell-group inset>
                        <van-field v-model="addStaffAsk.askname" readonly label="请假类型" @click="showAskPicker = true" placeholder="请假类型" :rules="[{ required: true, message: '请选择请假类型' }]"/>
                    </van-cell-group>-->
                    <van-cell-group inset>
                        <van-field v-model="addStaffAsk.startdatename" readonly label="日期" @click="showWDKDateFromPicker = true" placeholder="开始时间" :rules="[{ required: true, message: '请选择开始时间' }]"/>
                    </van-cell-group>
                    <van-cell-group inset>
                        <van-field  is-link readonly v-model="addStaffAsk.checkintime" label="到店时间" placeholder="点击选择时间" @click="showWDKTimePicker = true"/>
                    </van-cell-group>
                    <!--<van-cell-group inset>
                        <van-field v-model="addStaffAsk.enddatename" readonly label="结束时间" @click="showAskEndDateFromPicker = true" placeholder="结束时间" :rules="[{ required: true, message: '请选择结束时间' }]"/>
                    </van-cell-group>-->
                    <!--<van-cell-group inset>
                        <van-field v-model="addStaffAsk.days" readonly label="请假天数" placeholder="请假天数"/>
                    </van-cell-group>-->
                    <!--<van-cell-group inset>
                        <van-field v-model="addStaffAsk.reason" rows="1" type="textarea" autosize label="请假原因" placeholder="请假原因"/>
                    </van-cell-group>-->
                    <van-cell-group inset>
                        <van-field name="uploader" label="忘打卡凭证">
                            <template #input>
                                <van-uploader :before-delete="beforeAskDelete" v-model="askImages" :after-read="afterAskRead" multiple/>
                            </template>
                        </van-field>
                    </van-cell-group>
                </van-form>
                <div style="margin: 16px;">
                    <van-button round block type="primary" :loading="loading" native-type="submit" @click="saveWdk">提交</van-button>
                </div>
                <van-popup v-model:show="showWDKDateFromPicker" position="bottom">
                    <van-picker show-toolbar :columns="wdkTime"  @confirm="askWDKTimeConfirm" @cancel="showWDKDateFromPicker = false"/>
                </van-popup>
                <van-popup v-model:show="showWDKTimePicker" position="bottom">
                    <van-datetime-picker type="datetime" v-model="checkWDKdatetime"  @confirm="onWDKTimeConfirm" @cancel="showTimePicker = false" />
                </van-popup>
            </el-dialog>
        </el-main>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            lxShow:false,
            lxChangeDateTime:"",
            lxDateFromPicker:false,
            showWDKTimePicker:false,
            checkWDKdatetime:"",
            wdkTime:[],
            showWDKDateFromPicker:false,
            dialogWDKVisible:false,
            lxDialogVisible:false,
            dialogChangeVisible:false,
            showAskEndDateFromPicker:false,
            showAskDateFromPicker:false,
            showAskPicker:false,
            dialogAskVisible:false,
            askImages:[],
            addStaffAsk:{},
            staffAsk:{
                storeid:"",
                sysbillid:"",
                staffid:"",
                startdate:"",
                startdatename:"",
                enddate:"",
                enddatename:"",
                askid:"",
                askname:"",
                days:0,
                status:1,
                reason:"",
                createdate:"",
                askAnnexes:[],
                strings:[],
                checkintime:"",
            },
            changetodatetime:this.$moment().toDate(),
            showToChangeTimePicker:false,
            showChangeTimePicker:false,
            loading:false,
            addCheckInChange:{},
            checkInChange:{
                sysbillid:"",
                staffid:"",
                staffname:"",
                changedate:"",
                tochangedate:"",
                changedateto:"",
                workdate2:"",
                workdate3:"",
                workdate4:"",
                workdate5:"",
                shiftid2:"",
                shiftid3:"",
                shiftid4:"",
                shiftid5:"",
                status:1,
                remarks:"",
                days:0,
                createdate:"",
            },
            changedatetime:this.$moment().toDate(),
            checkdatetime:"",
            showTimePicker:false,
            columns:[
                { text: '上班',value:1 },
                { text: '下班',value:2 }
            ],
            showTypePicker:false,
            showPicker:false,
            images:[],
            checkinreplace:{
                storeid:"",
                sysbillid:"",
                staffid:"",
                type:1,
                typename:"",
                checkindate:"",
                checkintime:"",
                status:"",
                remarks:"",
                createdate:"",
                strings:[],
                filelist:[],
            },
            addCheckInReplace:{},
            dialogVisible:false,
            tableData:[],
            staffid:"",
            curRow:{},
            curIndex:0,
            staff:null,
            askTime:[],
            askData:[],
            curDateName:"",
        }
    },
    created:function () {
        let posid=localStorage.getItem("posid");
        let storeid=localStorage.getItem("storeid");
        if(posid=="9132ffd069fd494687c1c9bc929baf5d" || posid=="ceb744d8bb9747849b3c7e997d0df357"
            || "9d6032cc834748f5bc2932ff73bd9d57"==posid || "d6511059fec84700a91a86e43436fd58"==posid){//领导层能看见
            this.lxShow=true;
        }
        else if(storeid=="6862df117e404dffac984820fe15e320"){//总部也能看见
            this.lxShow=true;
        }
        this.getStaffCheckInDataByStaffId();
        this.getStaffAskTime();
        this.getAskInfo();
        //this.getStaffCheckInDataByStaffId();
        /*let userId = this.getUrlKey("userId");
        let code = this.getUrlKey("code");
        if (userId || code) {
            if (userId) {
                this.getCorpUserInfo(userId);
            }
        } else {
            window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getThirdCorpidCodeNew?state=" + encodeURIComponent("http://staff.shmiaojie.cn/#/checkindata");
        }*/
    },
    updated() {
        this.$nextTick(() => {
            this.$refs['table'].doLayout();
        })
    },
    methods:{
        saveLxCheckInChange(){
            if(!this.addCheckInChange.changedate){
                this.$message({message:"请选择开始调休日期", type: 'error'});
                return;
            }
            if(!this.addCheckInChange.changedateto){
                this.$message({message:"请选择结束调休日期", type: 'error'});
                return;
            }
            if(!this.addCheckInChange.tochangedate){
                this.$message({message:"请选择补班日期1", type: 'error'});
                return;
            }
            if(!this.addCheckInChange.workdate2){
                this.$message({message:"请选择补班日期2", type: 'error'});
                return;
            }
            if(this.addCheckInChange.days>=3){
                if(!this.addCheckInChange.workdate3){
                    this.$message({message:"请选择补班日期3", type: 'error'});
                    return;
                }
            }
            if(this.addCheckInChange.days>=4){
                if(!this.addCheckInChange.workdate4){
                    this.$message({message:"请选择补班日期4", type: 'error'});
                    return;
                }
            }
            if(this.addCheckInChange.days>=5){
                if(!this.addCheckInChange.workdate5){
                    this.$message({message:"请选择补班日期5", type: 'error'});
                    return;
                }
            }
            if(!this.addCheckInChange.remarks){
                this.$message({message:"请输入调休原因", type: 'error'});
                return;
            }
            let staffid=localStorage.getItem("staffid");
            let storeid=localStorage.getItem("storeid");
            let staffname=localStorage.getItem("staffname");
            this.addCheckInChange.staffid=staffid;
            this.addCheckInChange.storeid=storeid;
            this.addCheckInChange.staffname=staffname;
            this.loading=true;
            this.$postw("wechatapprovalapply/saveLxCheckInChange",this.addCheckInChange).then(res=>{
                this.loading=false;
                if(res.sucess){
                    this.lxDialogVisible=false;
                    this.$message({message:"申请成功", type: 'success'});
                }
                else{
                    this.$message({message:res.message, type: 'error'});
                }
            });
        },
        lxCheckInChangeDate(){
            if(this.addCheckInChange.changedate && this.addCheckInChange.changedateto){
                let storeid=localStorage.getItem("storeid");
                let staffid=localStorage.getItem("staffid");
                this.$post("wechatapprovalapply/calCheckInChangeDays",{storeid:storeid,staffid:staffid,fromdate:this.addCheckInChange.changedate,
                    todate:this.addCheckInChange.changedateto}).then(res=>{
                    if(res.sucess){
                        let days=res.object.days;
                        if(days<2){
                            this.$message({message:"连续调休必须在两天以上", type: 'error'});
                            this.addCheckInChange.days=0;
                        }
                        else{
                            let data=res.object.data;
                            let i=0;
                            for(let val of data){
                                if(i==0){
                                    this.addCheckInChange.tochangedate=val;
                                }
                                else if(i==1){
                                    this.addCheckInChange.workdate2=val;
                                }
                                else if(i==2){
                                    this.addCheckInChange.workdate3=val;
                                }
                                else if(i==3){
                                    this.addCheckInChange.workdate4=val;
                                }
                                else if(i==4){
                                    this.addCheckInChange.workdate5=val;
                                }
                                i++;
                            }
                            this.addCheckInChange.days=days;
                        }
                    }
                    else{
                        this.addCheckInChange.days=0;
                        this.addCheckInChange[this.curDateName]="";
                        this.$message({message:res.message, type: 'error'});
                    }
                });
            }
        },
        openLxCheckInChange(){
            this.lxDialogVisible=true;
            this.addCheckInChange=this.$copy(this.checkInChange);
        },
        onLxChangeConfirm(val){
            this.addCheckInChange[this.curDateName]=this.$moment(val).format('YYYY-MM-DD');
            if(this.curDateName=="changedate" || this.curDateName=="changedateto"){
                this.lxCheckInChangeDate();
            }
            this.lxDateFromPicker=false;
        },
        openDate(name){
            this.lxDateFromPicker=true;
            this.curDateName=name;
            let val=this.addCheckInChange[name];
            if(val){
                this.lxChangeDateTime=val;
            }
            else{
                this.lxChangeDateTime=this.$moment().toDate();
            }
        },
        saveWdk(){
            if(!this.addStaffAsk.startdate){
                this.$message({message:"请选择日期", type: 'error'});
                return;
            }
            if(this.askImages.length<1){
                this.$message({message:"请上传监控照片", type: 'error'});
                return;
            }
            if(!this.addStaffAsk.checkintime){
                this.$message({message:"请选择到店时间", type: 'error'});
                return;
            }
            this.loading=true;
            this.addStaffAsk.storeid=localStorage.getItem("storeid");
            this.addStaffAsk.staffid=localStorage.getItem("staffid");
            this.$postw("wechatapprovalapply/staffAskWDKApply",this.addStaffAsk).then(res=> {
                this.loading = false;
                if (res.sucess) {
                    this.$message({
                        message: "请假申请成功，请等待审核",
                        type: 'success'
                    });
                    this.dialogWDKVisible = false;
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        askWDKTimeConfirm(val){
            this.addStaffAsk.startdate=val[0];
            if(val[1]=="上午"){
                this.addStaffAsk.startdate=this.addStaffAsk.startdate+" 00:00:00";
            }
            else if(val[1]=="下午"){
                this.addStaffAsk.startdate=this.addStaffAsk.startdate+" 12:00:00";
            }
            this.addStaffAsk.startdatename=val[0]+val[1];
            this.addStaffAsk.enddate=this.addStaffAsk.startdate;
            this.addStaffAsk.checkintime=val[0]+" 00:00:00";
            this.checkWDKdatetime=this.$moment(this.addStaffAsk.checkintime).toDate();;
            this.showWDKDateFromPicker=false;
            this.calAskDays();
        },
        openWDK(){
            this.askImages=[];
            this.dialogWDKVisible=true;
            this.addStaffAsk=this.$copy(this.staffAsk);
            this.addStaffAsk.askid="101";
            this.addStaffAsk.askname="忘打卡";
            this.checkWDKdatetime=this.$moment().toDate();
        },
        openCheckInChange(){
            this.dialogChangeVisible=true;
            this.addCheckInChange=this.$copy(this.checkInChange);
        },
        staffAskApply(){
            if(!this.addStaffAsk.askid){
                this.$message({message:"请选择请假类型", type: 'error'});
                return;
            }
            if(!this.addStaffAsk.startdate){
                this.$message({message:"请选择请假开始时间", type: 'error'});
                return;
            }
            if(!this.addStaffAsk.enddate){
                this.$message({message:"请选择请假结束时间", type: 'error'});
                return;
            }
            if(!this.addStaffAsk.reason){
                this.$message({message:"请填写请假原因", type: 'error'});
                return;
            }
            this.loading=true;
            this.addStaffAsk.storeid=localStorage.getItem("storeid");
            this.addStaffAsk.staffid=localStorage.getItem("staffid");
            this.$postw("wechatapprovalapply/staffAskApply",this.addStaffAsk).then(res=>{
                this.loading=false;
                if(res.sucess){
                    this.$message({
                        message: "请假申请成功，请等待审核",
                        type: 'success'
                    });
                    this.dialogAskVisible=false;
                }
                else{
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        openStaffAsk(){
            this.askImages=[];
            this.dialogAskVisible=true;
            this.addStaffAsk=this.$copy(this.staffAsk);
        },
        calAskDays(){
            //console.log(this.addStaffAsk.startdate,this.addStaffAsk.enddate)
            if(!this.addStaffAsk.startdate || !this.addStaffAsk.enddate){
                this.addStaffAsk.days=0;
            }
            else{
                this.$post("checkindata/calAskDays",{starttime:this.addStaffAsk.startdate,endttime:this.addStaffAsk.enddate}).then(res => {
                    if(res.sucess){
                        this.addStaffAsk.days=res.object;
                    }
                    else{
                        this.$message({message:res.message, type: 'error'});
                    }
                });
            }
        },
        askEndTimeConfirm(val){
            this.addStaffAsk.enddate=val[0];
            if(val[1]=="上午"){
                this.addStaffAsk.enddate=this.addStaffAsk.enddate+" 00:00:00";
            }
            else if(val[1]=="下午"){
                this.addStaffAsk.enddate=this.addStaffAsk.enddate+" 12:00:00";
            }
            this.addStaffAsk.enddatename=val[0]+val[1];
            this.showAskEndDateFromPicker=false;
            this.calAskDays();
        },
        askStartTimeConfirm(val){
            this.addStaffAsk.startdate=val[0];
            //console.log(val);
            if(val[1]=="上午"){
                this.addStaffAsk.startdate=this.addStaffAsk.startdate+" 00:00:00";
            }
            else if(val[1]=="下午"){
                this.addStaffAsk.startdate=this.addStaffAsk.startdate+" 12:00:00";
            }
            this.addStaffAsk.startdatename=val[0]+val[1];
            this.showAskDateFromPicker=false;
            this.calAskDays();
        },
        AskConfirm(val){
            this.addStaffAsk.askid=val.constantid;
            this.addStaffAsk.askname=val.constantname;
            this.showAskPicker=false;
        },
        getAskInfo(){
            this.$post("checkindata/getAskInfo").then(res => {
                if(res.sucess){
                    this.askData=res.object;
                }
                else{
                    this.$message({message:res.message, type: 'error'});
                }
            });
        },
        getStaffAskTime(){
            this.$post("checkindata/getStaffAskTime").then(res => {
                if(res.sucess){
                    //console.log(this.askTime);
                    //console.log(res.object);
                    this.askTime=res.object;
                    this.wdkTime=this.askTime;

                }
                else{
                    this.$message({message:res.message, type: 'error'});
                }
            });
        },
        checkInChangeAppay(){
            if(!this.addCheckInChange.changedate){
                this.$message({message: "请选择上班日期", type: 'error'});
                return;
            }
            if(!this.addCheckInChange.tochangedate){
                this.$message({message: "请选择补班日期", type: 'error'});
                return;
            }
            if(!this.addCheckInChange.remarks){
                this.$message({message: "请填写调休原因", type: 'error'});
                return;
            }
            this.addCheckInChange.staffid=localStorage.getItem("staffid");
            this.$postw("wechatapprovalapply/checkInChangeAppay",this.addCheckInChange).then(res=>{
                if(res.sucess){
                    this.$message({message: "申请成功", type: 'success'});
                    this.dialogChangeVisible=false;
                }
                else{
                    this.$message({message:res.message, type: 'error'});
                }
            });
        },
        beforeAskDelete(file,detail){
            this.askImages.splice(detail.index,1);
            this.addStaffAsk.askAnnexes.splice(detail.index,1);
            this.addStaffAsk.strings.splice(detail.index,1);
        },
        beforeDelete(file,detail){
            this.addCheckInReplace.filelist.splice(detail.index,1);
            this.addCheckInReplace.strings.splice(detail.index,1);
        },
        wechatUpload(formData,type){
            this.$upload("wechatapprovalapply/wechatCompUpload", formData).then(res => {
                if (res.sucess) {
                    if(type==1) {
                        this.addCheckInReplace.strings.push(res.object);
                    }
                    else if(type==2){
                        this.addStaffAsk.strings.push(res.object);
                    }
                } else {
                    this.$message({message: res.message, type: 'error'});
                }
            });
        },
        saveCheckinReplace() {
            if(this.addCheckInReplace.type==0){
                this.$message({
                    message: "请选择补卡类型",
                    type: 'error'
                });
                return;
            }
            if(this.addCheckInReplace.checkintime.indexOf("00:00")!=-1){
                this.$message({
                    message: "请选择补卡时间",
                    type: 'error'
                });
                return;
            }
            if(this.addCheckInReplace.filelist.length<1){
                this.$message({
                    message: "请上传监控图片,证明你打过卡了",
                    type: 'error'
                });
                return;
            }
            this.loading=true;
            this.addCheckInReplace.storeid=localStorage.getItem("storeid");
            this.addCheckInReplace.staffid=localStorage.getItem("staffid");
            this.$postw("checkindata/saveCheckinReplace",this.addCheckInReplace).then(res=>{
                if(res.sucess){
                    this.loading=false;
                    this.$message({
                        message: "补卡申请成功，请等待审核",
                        type: 'success'
                    });
                    this.dialogVisible=false;
                }
                else{
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        filePathUpload(formData,type){
            this.$upload("file/filePathUpload?path=checkreplace",formData).then(res=>{
                if(res.sucess) {
                    if(type==1) {
                        this.addCheckInReplace.filelist.push(res.object);
                    }
                    else if(type==2){
                        let ask={};
                        ask.imageurl=res.object;
                        this.addStaffAsk.askAnnexes.push(ask);
                    }
                }
                else{
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
        },
        afterAskRead(event){
            let formData = new FormData();
            formData.append('file', event.file);
            this.filePathUpload(formData,2);
            this.wechatUpload(formData,2);
        },
        afterRead(event){
            let formData = new FormData();
            formData.append('file', event.file);
            this.filePathUpload(formData,1);
            this.wechatUpload(formData,1);
        },
        onToChanageConfirm(val){
            this.addCheckInChange.tochangedate=this.$moment(val).format('YYYY-MM-DD');
            this.showToChangeTimePicker=false;
        },
        onChangeConfirm(val){
            this.addCheckInChange.changedate=this.$moment(val).format('YYYY-MM-DD');
            this.showChangeTimePicker=false;
        },
        onTimeConfirm(val){
            this.addCheckInReplace.checkintime=this.$moment(val).format('YYYY-MM-DD HH:mm');
            this.showTimePicker=false;
        },
        onWDKTimeConfirm(val){
            this.addStaffAsk.checkintime=this.$moment(val).format('YYYY-MM-DD HH:mm');

            this.showWDKTimePicker=false;
        },
        onConfirm(val,index){
            console.log(val);
            this.addCheckInReplace.type = val.value;
            this.addCheckInReplace.typename=val.text;
            this.showTypePicker=false;
        },
        openApply(scope){
            this.addCheckInChange=this.$copy(this.checkInChange);
            this.images=[];
            this.addCheckInReplace=this.$copy(this.checkinreplace);
            this.addCheckInReplace.staffid=scope.row.staffid;
            this.addCheckInReplace.checkindate=scope.row.checkindate;
            this.checkdatetime=this.$moment(this.addCheckInReplace.checkindate).toDate();
            this.dialogVisible=true;
        },
        getCorpUserInfo(staffid) {
            this.$post("wechat/getCorpUserInfo", {staffid: staffid}).then(res => {
                if (res.sucess) {
                    let data = res.object;
                    if (data.staff == null || data.staff == undefined) {
                        this.$message.error('没有找到您的信息');
                    } else {
                        this.staff = data.staff;
                        this.staffid=data.staff.staffid;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("deptid", data.staff.deptid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        localStorage.setItem("storename", data.staff.storename);
                        localStorage.setItem("storeid", data.staff.storeid);
                        localStorage.setItem("parentstoreid", data.staff.storeid);
                        let posid=data.staff.posid;
                        if(posid=="9132ffd069fd494687c1c9bc929baf5d" || posid=="ceb744d8bb9747849b3c7e997d0df357"
                            || "9d6032cc834748f5bc2932ff73bd9d57"==posid || "d6511059fec84700a91a86e43436fd58"==posid){//领导层能看见
                            this.lxShow=true;
                        }
                        else if(data.staff.storeid=="6862df117e404dffac984820fe15e320"){//总部也能看见
                            this.lxShow=true;
                        }
                        this.getStaffCheckInDataByStaffId();
                        this.getStaffAskTime();
                        this.getAskInfo();
                    }
                } else {
                    window.close();
                }
            });
        },
        getStaffCheckInDataByStaffId(){
            let staffid=localStorage.getItem("staffid");
            let storeid=localStorage.getItem("storeid");
            this.$post("checkindata/getStaffCheckInDataByStaffId",{storeid:storeid,userid:staffid}).then(res=>{
                if(res.sucess){
                    this.tableData=res.object;
                }
                else{
                    this.$message.error(res.message);
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/checkindata/checkindata.vue